import axiosApiInstance from '../../../api/axiosClient';

export type DDEXBatchScope = {
    client_podio?: string;
    label_id?: string;
    release_ids?: string[];
};

export type DDEXBatchJobStatus = {
    phase: string;
    upcs_done: number;
    upcs_total: number;
    bytes_done: number;
    bytes_total: number;
    error?: string;
};

export type DDEXBatchStartResponse = {
    job_id: string;
    upc_count: number;
    estimated_seconds: number;
    estimated_bytes: number;
};

export async function startDDEXBatch(
    scope: DDEXBatchScope,
    searchParams: Record<string, unknown>,
): Promise<DDEXBatchStartResponse> {
    const {data} = await axiosApiInstance.post<DDEXBatchStartResponse>(
        '/api/products/releases/ddex-package-batch',
        scope,
        {params: {...searchParams, is_pending: false}},
    );
    return data;
}

export async function pollDDEXBatchStatus(jobId: string): Promise<DDEXBatchJobStatus> {
    const {data} = await axiosApiInstance.get<DDEXBatchJobStatus>(
        `/api/products/releases/ddex-package-batch/${jobId}`,
    );
    return data;
}

export async function downloadDDEXBatchFile(jobId: string, filename: string) {
    const response = await axiosApiInstance.get<Blob>(
        `/api/products/releases/ddex-package-batch/${jobId}/file`,
        {responseType: 'blob', skipErrorNotification: true},
    );
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

export function formatBytes(n: number) {
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatEta(seconds: number) {
    if (seconds < 60) return `about ${seconds} seconds`;
    const m = Math.ceil(seconds / 60);
    return `about ${m} minute${m === 1 ? '' : 's'}`;
}
